import React from 'react';
import '../.././components/css/popupstyle.css';
import $ from 'jquery';
import { userService } from '../../_services/user.service';

class GlicAddApi extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loader: false,
            userdata: JSON.parse(localStorage.getItem('user')),
            errorIpAddress: '',
            successIpAddress: '',
            ipAddress: '',
            sType: false,
            disableBtn: false
        }
    }
    componentDidMount() {
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
        this.handleChange = this.handleChange.bind(this)
        if (this.props.glicIps && this.props.glicIps.length) {
            const definedstype = this.props.glicIps[0].sType === 'Dynamic IP' ? true : false
            this.setState({ sType: definedstype })
        }
        /*if (userService.Check_LoggedIn_Status() == 'Login') {
            return <Redirect to="/login" />
        } else {
            this.GetWhiteListedIPs(this.state.userdata.unique_ObjectId, this.state.userdata.email);
        }*/
    }
    /*GetWhiteListedIPs(ObjectUid, EmailId) {
        try {
            userService.GetWhiteListedIP(ObjectUid, EmailId, []).then(
                apidata => {
                    if (apidata.length > 0) {
                        this.setState({ ipsList: apidata })
                    }
                }
            );
        }
        catch (error) { }
    }
    */
    AddWhiteListedIPs() {
        try {
            const preAddedIps = this.props.glicIps
            const isDynamic = this.state.sType
            const checkExisting = preAddedIps.find((ip) => ip.ipAddress === this.state.ipAddress)
            const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
            const domainRegex = /^(?:https?:\/\/)?(?:([a-zA-Z0-9-]+)\.)?([a-zA-Z0-9-]+)\.([a-zA-Z]{2,})(?:\/|$)/;
            if (this.state.ipAddress === '' || this.state.ipAddress === null || this.state.ipAddress === undefined) {
                const errorMsgStr = isDynamic ? 'Domain name is required. Example of a valid Domain name: example.com or sub.example.com' : 'IP address is required. Example of a valid IP: 192.168.1.1'
                this.setState({ errorIpAddress: errorMsgStr, successIpAddress: '' });
                return false;
            }
            if (!domainRegex.test(this.state.ipAddress) && isDynamic) {
                this.setState({ errorIpAddress: `Domain name is not valid. Example of a valid Domain name: example.com or sub.example.com`, successIpAddress: '' });
                return false;
            }
            if (!ipv4Regex.test(this.state.ipAddress) && !isDynamic) {
                this.setState({ errorIpAddress: `IP address is not valid. Example of a valid IP: 192.168.1.1`, successIpAddress: '' });
                return false;
            }
            if (checkExisting !== null && checkExisting !== undefined && checkExisting !== '') {
                this.setState({ errorIpAddress: `IP address is already added in the list. Please try another IP.`, successIpAddress: '' });
                return false;
            }
            this.setState({ disableBtn: true })
            userService.ProcessWhiteListIP(this.state.userdata.wholesaler_Id.toString(), this.state.userdata.email, this.state.ipAddress, this.state.sType).then(
                apidata => {
                    if (apidata[0].code === '1') {
                        this.setState({ successIpAddress: apidata[0].message, errorIpAddress: '' })
                        if (this.props.ipAddressUpdated) this.props.ipAddressUpdated()
                        setTimeout(() => {
                            this.setState({ disableBtn: false })
                            if (this.props.closeGlicAddApiPopup) this.props.closeGlicAddApiPopup()
                        }, 2000)
                    } else {
                        this.setState({ errorIpAddress: apidata[0].message, successIpAddress: '', disableBtn: false })
                    }
                }
            );
        }
        catch (error) {
            this.setState({ disableBtn: false })
        }
    }
    handleChange(e, index) {
        this.setState({ errorIpAddress: '', successIpAddress: '' })
        const { value } = e.target;
        //if (value !== '') {
        //const newIpsList = [...this.state.ipsList]
        //newIpsList[index] = value
        this.setState({ ipAddress: value })
        /*} else {
            this.setState({ errorIpAddress: 'IP Address field can not be empty. Please add IP or delete field', successIpAddress: '' })
        }*/
    }
    handleStypeChange(e) {
        this.setState({ errorIpAddress: '', successIpAddress: '' })
        const { checked } = e.target;
        this.setState({ sType: checked })
        if (this.props.stypeChanged) this.props.stypeChanged(checked)
    }
    /*handleAddField() {
        const lastEntry = this.state.ipsList[this.state.ipsList.length - 1]
        const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        if (this.state.ipsList.length > 0) {
            for (let i = 0; i < this.state.ipsList.length; i++) {
                if (!ipv4Regex.test(this.state.ipsList[i])) {
                    this.setState({ errorIpAddress: `IP Address ${this.state.ipsList[i]} is not valid`, successIpAddress: '' });
                    return false;
                }
            }
            const emptyIps = this.state.ipsList.filter((item) => item === '' || item === undefined || item === null)
            if (emptyIps.length > 0) {
                this.setState({ errorIpAddress: 'IP Address field can not be empty. Please add IP or delete field', successIpAddress: '' })
                return false
            }
        }
        if ((lastEntry && lastEntry !== '') || this.state.ipsList.length === 0) {
            this.setState({ errorIpAddress: '', successIpAddress: '', ipsList: [...this.state.ipsList, ''] })
        } else {
            this.setState({ errorIpAddress: 'Please fill previous field first', successIpAddress: '' })
        }
    }
    handleRemoveField(indexToRemove) {
        this.setState({
            ipsList: this.state.ipsList.filter((_, index) => index !== indexToRemove),
        });
    }*/
    render() {
        const { loader, errorIpAddress, successIpAddress } = this.state;
        return (
            <div className='popup mfp-zoom-in glicAddApiPopup'>
                <div className='popup_inner manage-distributor-design glic-api' style={{minHeight: 'auto'}}>
                    {
                        loader ? (<div className="theme-loader"></div>) : null
                    }
                    <h1>{this.props.text}<button onClick={this.props.closeGlicAddApiPopup}>X</button></h1>
                    <div className="api-section referralPopup">
                        {!this.props.glicIps.length ? <div className="checkbox-section">
                            <div className="same-checkbox"> <div><input type="checkbox" id="sType" onChange={(e) => this.handleStypeChange(e)} name="sType" value="" style={{ display: 'none' }} checked={this.state.sType} /><label for="sType"><span className="checkmark"></span>Add Dynamic IP</label></div></div>
                        </div> : null}
                        <div className="form-group">
                            <input type="text" id='ipAddress' className="form-control" name="ipAddress" placeholder={`Please enter ${this.state.sType ? "Domain name" : "IP address"}`} value={this.state.ipAddress} onChange={(e) => this.handleChange(e)} autoComplete="off" />
                        </div>
                        {(errorIpAddress || successIpAddress) ?
                            <div className="form-group"><div className="Error help-block">{errorIpAddress || successIpAddress}</div></div> : null
                        }
                    </div>
                    <div className="api-btn">
                        <input type="button" className='btn' value="Save" onClick={this.AddWhiteListedIPs.bind(this)} disabled={this.state.disableBtn} />
                        <input type="button" className='btn close-btn' onClick={this.props.closeGlicAddApiPopup} value="Close" />
                    </div>
                </div>
            </div>
        );
    }
}
export default GlicAddApi;
